module.exports = __webpack_public_path__ + "static/media/app-store.ac255f08.svg";